const ClickAllTrilhas = "Click All Trilhas";
const ClickAllTrilhasAction = "Click_All_Trilhas_Action";

export default ClickAllTrilhas;
export { ClickAllTrilhas, ClickAllTrilhasAction };
